module.exports = __webpack_public_path__ + "img/INDU.7d2ed60a.jpg";